<template>
<div>
  <div v-if='isLeftSide' class='discount-label discount-label-left' :style="dynamicLabelStyle">
      <div class='text' :style="dynamicTextStyle" :lang="narratorLang" tabindex="-1" :aria-label="text">
          <span class="star">*</span>{{text}}
      </div>
  </div>
  <div v-else class='discount-label' :style="[dynamicLabelStyle,dynamicRightLabelBackground]">
      <div class='text' :style="dynamicTextStyle" :lang="narratorLang" tabindex="-1" :aria-label="text">
          {{text}}<span class="star">*</span>
      </div>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'DiscountLabel',
    props: {
        text: {
            type: String,
            required: false,
            default: '',
        },
        padding: {
            type: String,
            required: false,
            default: '0 10px 0 0',
        },
        rotateValue: {
            type: Number,
            required: false,
            default: -5,
        },
        isLeftSide: {
            type: Boolean,
            required: false,
            default: true,
        },
        rightSideBackgroundColor: {
            type: String,
            required: false,
            default: 'yellow',
        },
        labelHeight: {
            type: Number,
            required: false,
            default: 37,
        },
        labelWidth: {
            type: Number,
            required: false,
            default: 80,
        },
        textColor: {
            type: String,
            required: false,
            default: '#333333',
        },
        fontSize: {
            type: Number,
            required: false,
            default: 14,
        },
        isRotated: {
            type: Boolean,
            required: false,
            default: false,
        },

    },
    computed: {
        ...mapGetters({
            getLang: 'settings/userSelectedLanguage',
            narratorLang: 'settings/getNarratorLanguage',
        }),
        dynamicTextStyle() {
            return {
                transform: `rotate(${this.rotateValue}deg)`,
                color: this.textColor,
                fontSize: `${this.fontSize}px`,
            };
        },
        dynamicLabelStyle() {
            return {
                padding: `${this.padding}`,
                height: `${this.labelHeight}px`,
                width: `${this.labelWidth}px`,
            };
        },
        dynamicRightLabelBackground() {
            return {
                backgroundImage: this.rightSideBackgroundColor == 'yellow' ? "url('/static/img/icons/discount-label-right.svg')" :
                 this.rightSideBackgroundColor == 'blue' ? "url('/static/img/icons/discount-right-blue-label.svg')" :
                 this.rightSideBackgroundColor == 'white' && this.isRotated ? "url('/static/img/icons/discount-right-white-rotated-label.svg')" :
                 "url('/static/img/icons/discount-right-white-label.svg')",
            };
        },
    },
};
</script>

<style scoped lang='scss'>
    .discount-label{
        display: flex;
        align-items: center;
        justify-content: center;
        .text{
            font-family: Roboto;
            font-size: 14px;
            font-weight: 500;
            font-stretch: normal;
            .star {
                font-size: 12px;
                position: absolute;
                top: 0;
                right: -8px;
            }
        }
        &.discount-label-left{
            background-image: url("/static/img/icons/discount-label-left.svg");
        }
    }

</style>
